/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */


import api, {
  partHeader, 
  apiInternal
 } from '../../api.js';



const state = {
  schedulesByMonth: [],
};

const getters = {

};

const actions = {
  async getBillingScheduleForMonth({ commit }, month) {
    const result = await api.post(`${apiInternal}/getBilling`,{month},partHeader);
    if (result) commit('setSchedule', result.data);
    return result;

  },
  async billPaid({ state, commit }, [bilsId, bilsAmount]) {
    const result = await api.post(`${apiInternal}/setBillPaid`,{ bilsId, bilsAmount },partHeader);
    if (result) commit('updateSchedule', result.data);
    return result;

  },
  async billSent({  commit }, bilsId) {
    const result = await api.post(`${apiInternal}/setBillSent`,{ bilsId},partHeader);
    if (result) commit('updateSchedule', result.data);
    return result;
  },
};

const mutations = {
  setSchedule(data, schedules) {
    data.schedulesByMonth = schedules;
    // TODO : set date properly
  },
  updateSchedule(data, newSchedule) {
    console.log('updateSchedule');
    const index = state.schedulesByMonth.findIndex(schedule => schedule.bils_id === newSchedule.bils_id);
    if (index >= 0) {
      data.schedulesByMonth.splice(index, 1, newSchedule);
    } else {
      data.schedulesByMonth.push(newSchedule);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
